class TogglePet extends HTMLElement {
    constructor() {
        super();

        this.uploaderId = 'a57f25dd-9e31-4938-9916-0b97794326fa';

        this.uploaderSelector = `[data-uploader-id="${this.uploaderId}"]`;

        this.uploader = document.querySelector(this.uploaderSelector);
        this.toggle = document.getElementById('AddAdditionalPet');
        this.uploaderContainer = this.querySelector('.upload_photo');

        if (!this.uploader) {
            return document.addEventListener('script:loaded:uploadkit-app.js', () => {
                this.uploader = document.querySelector(this.uploaderSelector);
                if (!this.uploader)
                    console.error("Couldn't find uploader, selector: ", this.uploaderSelector);
                this.init();
            });
        }

        this.init();
    }

    init() {
        this.uploaderContainer.appendChild(this.uploader);
        this.uploader.style.display = 'block';

        this.toggle.addEventListener('change', this.handleToggleChange.bind(this));
    }

    handleToggleChange() {
        if (!this.uploaderInstance) {
            UploadKit.containers.push(this.uploaderContainer);
            this.uploaderInstance = UploadKit.activeUploaders.find((upldr) => upldr.id === this.uploaderId);
        }

        if (this.toggle.checked) {
            this.showUploader();
        } else {
            this.removeUploader();
        }
        document.querySelector('.canvas-list__list .selected')?.click();
    }

    showUploader() {
        window.theme.priceAddition = 2500;
        this.uploaderContainer.classList.remove('hidden');
    }

    removeUploader() {
        window.theme.priceAddition = 0;
        this.uploaderContainer.classList.add('hidden');
        this.resetUploader();
    }

    resetUploader() {
        this.uploaderInstance.fileObject = null;
        this.uploaderInstance.files = [];
        UploadKit.refreshUploader(this.uploaderInstance);
    }
}

customElements.define('toggle-pet', TogglePet);
